import { GameSettings } from '@colonist/game-base-types';
import { navigateToPage } from '../ui_utils/ClientUtils.ts';
import { translate } from '../ui_utils/DomUtils.ts';
import { DELETED_USER_USERNAME } from '../../../../shared/UserState.ts';
import { CA } from '../analytics/Analytics.ts';
import { AnalyticEventCategory, AnalyticEventType } from '../../../../shared/entity_datas/EntityDatas.ts';
import { GameModeDataController } from '@colonist/shared-types';
import { MapDataController } from '../../../../shared/map_data/MapDataController.ts';
import { getDiceSettingText, getExtensionSettingText, getScenarioSettingText, PlayerEnums } from '../../../../shared/GameEnums.ts';
import { UIUtilsEjsVariables } from '../UIUtilsEjsVariables.ts';
import { TimeUtils } from '@colonist/utils';
export function toHistoryGameViews(games, profileUserId, options) {
    const newestFirst = [
        ...games
    ].reverse();
    return newestFirst.map((game)=>toHistoryGameView(game, profileUserId, options.isPopup));
}
export function navigateToReplay(gameId, replayUrl) {
    if (replayUrl == undefined) return;
    void CA.sendAnalyticEvent({
        type: AnalyticEventType.ReplayClickedViewFromProfileGameHistory,
        category: AnalyticEventCategory.Replay,
        stringValue: gameId
    });
    navigateToPage(replayUrl, true);
}
function toHistoryGameView(game, profileUserId, isPopup) {
    var _game_players_find;
    const setting = GameSettings.deserialize(game.setting);
    const profileColorInGame = (_game_players_find = game.players.find((player)=>player.userId === profileUserId)) === null || _game_players_find === void 0 ? void 0 : _game_players_find.playerColor;
    const hasReplay = game.hasReplay && profileColorInGame != undefined;
    return {
        id: game.id,
        dateText: TimeUtils.convertTimestampToDateTimeText(game.startTime),
        durationText: TimeUtils.formatSecondsToElapsedString(game.duration / TimeUtils.MILLISECONDS),
        victoryPointsToWin: setting.victoryPointsToWin,
        turnCount: game.turnCount,
        players: game.players.map(toHistoryPlayer),
        settings: toHistoryGameSettings(setting),
        replayUrl: hasReplay ? getReplayUrl(game, profileColorInGame, isPopup) : undefined
    };
}
function toHistoryPlayer(player) {
    const username = player.isHuman ? player.username : translate('strings:profilePage.history.botName');
    return {
        username: username,
        hasProfile: player.isHuman && player.username != DELETED_USER_USERNAME,
        rank: player.rank,
        points: player.points,
        finished: player.finished,
        quitWithPenalty: player.quitWithPenalty
    };
}
function toHistoryGameSettings(setting) {
    const gameModeData = GameModeDataController.getModeDataForMode(setting.modeSetting);
    if (gameModeData == undefined) return undefined;
    return {
        id: setting.id,
        mapName: MapDataController.getMapName(setting.mapSetting),
        modeName: gameModeData.name,
        extensionName: getExtensionSettingText(setting.extensionSetting),
        scenarioName: getScenarioSettingText(setting.scenarioSetting),
        diceText: getDiceSettingText(setting.diceSetting),
        turnTimerText: PlayerEnums.getSpeedSettingText(setting.gameSpeed),
        friendlyRobber: setting.friendlyRobber,
        karmaActive: setting.karmaActive,
        hideBankCards: setting.hideBankCards,
        cardDiscardLimit: setting.cardDiscardLimit
    };
}
function getReplayUrl(game, profileColorInGame, isPopup) {
    if (UIUtilsEjsVariables.isUserOnDiscord && isPopup) return `https://colonist.io/replay?gameId=${game.id}&playerColor=${profileColorInGame}`;
    if (UIUtilsEjsVariables.isUserOnDiscord) return `/replay?gameId=${game.id}&playerColor=${profileColorInGame}`;
    const replayUrl = new URL(window.location.href);
    replayUrl.pathname = UIUtilsEjsVariables.isUserOnMobileAppOrWeb ? '/mobile/replay' : '/replay';
    replayUrl.searchParams.set('gameId', game.id.toString());
    replayUrl.searchParams.set('playerColor', profileColorInGame.toString());
    return replayUrl.href;
}
